import { takeEvery, put, all, select } from 'redux-saga/effects';
import { openModalDialog } from '@nextiva/crm-modals';
import { listActions, listReducer } from '@nextiva/engagement-ui';

import modalTypes from 'constants/AppModalTypes';
import isSurveyStatusChangeConfirmationRequired from 'utils/isSurveyStatusChangeConfirmationRequired';
import { FAVORITE } from 'constants/surveyList/SurveyTabKeys';
import * as actions from 'constants/surveyList/SurveyListActions';
import * as surveyApi from 'api/surveyList';
import { loadSurveyList, patchSurveyStatus, patchSurveyShowInMenuValue } from 'actions/surveyListActions';
import { getSurveyStatus } from 'reducers/itemListReducer';
import { getSurveyResponseCount } from '../../reducers/itemListReducer';

const { toggleTileFavorite, updateItemListData } = listActions;
const { getItemListTabName } = listReducer;

function* onSortSurveyListColumn({ payload: { listId, field, order } }) {
  const currentTabName = yield select(getItemListTabName, listId);
  yield put(
    loadSurveyList(listId, {
      pageNumber: 0,
      onlyFavorites: currentTabName === FAVORITE,
      sortBy: field,
      sortOrder: order,
    }),
  );
}

function* onToggleSurveyFavorite({ payload: { listId, itemId, isFavorite } }) {
  yield put(toggleTileFavorite(listId, surveyApi.changeSurveyIsFavorite, itemId, isFavorite));
}

function* onChangeShowInMenuValue({ payload: { listId, itemId, value } }) {
  if (itemId) yield put(patchSurveyShowInMenuValue(listId, itemId, value));
}

function* onChangeSurveyStatus({ payload: { listId, itemId, status } }) {
  const currentStatus = yield select(getSurveyStatus, listId, itemId);
  const responseCount = yield select(getSurveyResponseCount, listId, itemId);
  yield put(
    isSurveyStatusChangeConfirmationRequired(currentStatus, status)
      ? openModalDialog({
          type: modalTypes.changeSurveyStatus,
          surveyId: itemId,
          status,
          listId,
          responseCount,
        })
      : patchSurveyStatus(listId, itemId, status),
  );
}

function* onPatchSurveyStatusSuccess({ listId, data }) {
  // ItemList can be null, if we open application on survey editor page @e.batrak
  if (listId) yield put(updateItemListData(listId, data.id, data));
}

function* onPatchShowInMenuValueSuccess({ listId, data }) {
  if (listId) yield put(updateItemListData(listId, data.id, data));
}

export default function*() {
  yield all([
    takeEvery(actions.SORT_SURVEY_LIST_COLUMN, onSortSurveyListColumn),
    takeEvery(actions.TOGGLE_SURVEY_FAVORITE, onToggleSurveyFavorite),
    takeEvery(actions.CHANGE_SURVEY_STATUS, onChangeSurveyStatus),
    takeEvery(actions.CHANGE_SURVEY_SHOW_IN_MENU_VALUE, onChangeShowInMenuValue),
    takeEvery(actions.PATCH_SURVEY_STATUS_SUCCESS, onPatchSurveyStatusSuccess),
    takeEvery(actions.PATCH_SURVEY_SHOW_IN_MENU_SUCCESS, onPatchShowInMenuValueSuccess),
  ]);
}
